import React from "react";
import { IDS } from "@/constants/testIds";
import { SectionHeader } from "@/sections/Services";

const steps = [
  {
    code: "01",
    title: "Scope & threat-model",
    desc: "We pressure-test your spec, surface attack surfaces, define invariants, and lock the architecture before any code is shipped.",
    out: "design doc · invariants · timeline",
  },
  {
    code: "02",
    title: "Build · iterate · review",
    desc: "Weekly demos on devnet. PR-level peer review, fuzz harness from day one, deterministic CI. No surprises at handover.",
    out: "devnet build · test report · ci pipeline",
  },
  {
    code: "03",
    title: "Audit-ready handoff",
    desc: "We coordinate with top external auditors (OtterSec, Trail of Bits, Zellic) and remediate findings — typically zero-critical pre-launch.",
    out: "audit report · remediations · launch plan",
  },
  {
    code: "04",
    title: "Mainnet · ops · monitor",
    desc: "Validator fleets, RPC, indexers, on-call rotation. We don't disappear at TGE — we keep the metal humming.",
    out: "24/7 monitoring · sla · runbooks",
  },
];

const Process = () => {
  return (
    <section
      id="process"
      data-testid={IDS.process}
      className="relative py-28 lg:py-36 border-t border-[rgba(0,255,65,0.12)]"
    >
      <div className="mx-auto max-w-[1280px] px-6 lg:px-10">
        <SectionHeader
          kicker="// 02 — Process"
          title="From spec to mainnet — the whole stack, one team."
          right="man process.1"
        />

        <ol className="mt-14 border border-[rgba(0,255,65,0.18)]">
          {steps.map((s, i) => (
            <li
              key={s.code}
              data-testid={IDS.processStep(i)}
              className={`grid grid-cols-12 gap-6 px-6 lg:px-10 py-8 lg:py-10 transition-colors hover:bg-[#0a0a0a] ${
                i !== steps.length - 1
                  ? "border-b border-[rgba(0,255,65,0.12)]"
                  : ""
              }`}
            >
              <div className="col-span-12 sm:col-span-2 flex sm:block items-center gap-4">
                <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                  step
                </div>
                <div className="font-mono text-[#00FF41] text-3xl sm:text-4xl glow-text">
                  {s.code}
                </div>
              </div>
              <div className="col-span-12 sm:col-span-6">
                <h3 className="font-mono text-xl sm:text-2xl text-white tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm sm:text-[15px] text-zinc-400 leading-relaxed max-w-[52ch]">
                  {s.desc}
                </p>
              </div>
              <div className="col-span-12 sm:col-span-4">
                <div className="text-[10px] uppercase tracking-[0.28em] text-zinc-500">
                  // output
                </div>
                <div className="mt-3 font-mono text-[13px] text-[#00FF41]">
                  &gt; {s.out}
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Process;
